import "./EditorToolbar.css";
import UTurnLeftIcon from "@mui/icons-material/UTurnLeft";
import SpellcheckOutlinedIcon from "@mui/icons-material/SpellcheckOutlined";
import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import ImagesearchRollerOutlinedIcon from "@mui/icons-material/ImagesearchRollerOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import FormatItalicOutlinedIcon from "@mui/icons-material/FormatItalicOutlined";
import FormatUnderlinedOutlinedIcon from "@mui/icons-material/FormatUnderlinedOutlined";
import FormatColorTextOutlinedIcon from "@mui/icons-material/FormatColorTextOutlined";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ExpandLessOutlinedIcon from "@mui/icons-material/ExpandLessOutlined";
import { GoBold } from "react-icons/go";

import { IoLink } from "react-icons/io5";

import {
  MdOutlineImage,
  MdOutlineFormatAlignLeft,
  MdOutlineFormatLineSpacing,
  MdOutlineChecklist,
  MdOutlineFormatListBulleted,
  MdOutlineFormatListNumbered,
} from "react-icons/md";
import { BiCommentAdd, BiRedo, BiUndo } from "react-icons/bi";

function EditorToolbar() {
  return (
    <header className="editorToolbar">
      <div className="editorToolbar__tools">
        <div className="editorToolbar__left">
          <div className="editorToolbar__tool">
            <BiUndo
              style={{
                // transform: "rotate(90deg)",
                color: "#444444",
                fontSize: 18,
              }}
            />
          </div>
          <div className="editorToolbar__tool">
            <BiRedo
              style={{
                // transform: "rotate(-90deg) rotateY(180deg)",
                color: "#444444",
                fontSize: 18,
              }}
            />
          </div>
          <div className="editorToolbar__tool">
            <LocalPrintshopOutlinedIcon
              style={{
                color: "#444444",
                fontSize: 18,
              }}
            />
          </div>
          <div className="editorToolbar__tool">
            <SpellcheckOutlinedIcon
              style={{
                color: "#444444",
                fontSize: 18,
              }}
            />
          </div>
          <div className="editorToolbar__tool">
            <ImagesearchRollerOutlinedIcon
              style={{
                color: "#444444",
                fontSize: 18,
              }}
            />
          </div>
          <div className="editorToolbar__tool editorToolbar__tool_multi-child">
            <p className="editorToolbar__tool_text">100%</p>
            <ArrowDropDownOutlinedIcon fontSize={"small"} />
          </div>
          <div className="editorToolbar__partition"></div>
          <div className="editorToolbar__tool editorToolbar__tool_multi-child">
            <p className="editorToolbar__tool_text">Normal text</p>
            <ArrowDropDownOutlinedIcon fontSize={"small"} />
          </div>
          <div className="editorToolbar__partition"></div>
          <div
            className="editorToolbar__tool editorToolbar__tool_multi-child"
            style={{ width: 85 }}
          >
            <p style={{ fontWeight: 500 }} className="editorToolbar__tool_text">
              Arial
            </p>
            <ArrowDropDownOutlinedIcon fontSize={"small"} />
          </div>
          <div className="editorToolbar__partition"></div>
          <div className="editorToolbar__tool">
            <RemoveOutlinedIcon
              style={{
                color: "#444444",
                fontSize: 18,
              }}
            />
          </div>
          <input value={"11"} type="text" className="editorToolbar__fontSize" />
          <div className="editorToolbar__tool">
            <AddOutlinedIcon
              style={{
                color: "#444444",
                fontSize: 18,
              }}
            />
          </div>
          <div className="editorToolbar__partition"></div>
          <div className="editorToolbar__tool">
            <GoBold
              style={{
                color: "#444444",
                fontSize: 15,
              }}
            />
          </div>
          <div className="editorToolbar__tool">
            <FormatItalicOutlinedIcon
              style={{
                color: "#444444",
                fontSize: 18,
              }}
            />
          </div>
          <div className="editorToolbar__tool">
            <FormatUnderlinedOutlinedIcon
              style={{
                color: "#444444",
                fontSize: 18,
              }}
            />
          </div>
          <div className="editorToolbar__tool">
            <FormatColorTextOutlinedIcon
              style={{
                color: "#444444",
                fontSize: 18,
              }}
            />
          </div>
          <div className="editorToolbar__tool">
            <BorderColorIcon
              style={{
                color: "#444444",
                fontSize: 18,
              }}
            />
          </div>
          {/* VERTICAL PARTITION */}
          <div className="editorToolbar__partition"></div>

          {/* LINK */}
          <div className="editorToolbar__tool">
            <IoLink
              style={{
                color: "#444444",
                fontSize: 18,
              }}
            />
          </div>
          {/* ADD COMMENT */}
          <div className="editorToolbar__tool">
            <BiCommentAdd
              style={{
                color: "#444444",
                fontSize: 18,
              }}
            />
          </div>
          {/* INSERT IMAGE */}
          <div className="editorToolbar__tool">
            <MdOutlineImage
              style={{
                color: "#444444",
                fontSize: 18,
              }}
            />
          </div>
          <div className="editorToolbar__partition"></div>

          {/* ALIGN LEFT */}
          <div className="editorToolbar__tool">
            <MdOutlineFormatAlignLeft
              style={{
                color: "#444444",
                fontSize: 18,
              }}
            />
            <ArrowDropDownOutlinedIcon fontSize={"small"} />
          </div>

          {/* FORMAT SPACING */}
          <div className="editorToolbar__tool">
            <MdOutlineFormatLineSpacing
              style={{
                color: "#444444",
                fontSize: 18,
              }}
            />
          </div>

          {/* CHECKLIST */}
          <div className="editorToolbar__tool">
            <MdOutlineChecklist
              style={{
                color: "#444444",
                fontSize: 18,
              }}
            />
            <ArrowDropDownOutlinedIcon fontSize={"small"} />
          </div>

          {/* BULLET LIST */}
          <div className="editorToolbar__tool">
            <MdOutlineFormatListBulleted
              style={{
                color: "#444444",
                fontSize: 18,
              }}
            />
            <ArrowDropDownOutlinedIcon fontSize={"small"} />
          </div>

          {/* NUMBERED LIST */}
          <div className="editorToolbar__tool">
            <MdOutlineFormatListNumbered
              style={{
                color: "#444444",
                fontSize: 18,
              }}
            />
          </div>

          {/* MORE OPTIONS */}
          <div className="editorToolbar__tool">
            <MoreVertIcon
              style={{
                color: "#444444",
                fontSize: 18,
              }}
            />
          </div>
        </div>

        {/* PENCIL ICON */}
        <div className="editorToolbar__right">
          <div className="editorToolbar__tool">
            <EditOutlinedIcon
              style={{
                color: "#444444",
                fontSize: 18,
                marginLeft: 4,
                marginRight: 7,
              }}
            />
            <ArrowDropDownOutlinedIcon fontSize={"small"} />
          </div>
          <div className="editorToolbar__partition"></div>
          <div className="editorToolbar__tool">
            <ExpandLessOutlinedIcon
              style={{
                color: "#444444",
                fontSize: 18,
              }}
            />
          </div>
        </div>
      </div>
    </header>
  );
}

export default EditorToolbar;
